import { useEffect, useState } from 'react'

let offTm: ReturnType<typeof setTimeout> | null = null

const ScreenLoader = () => {
  const [isOff, setIsOff] = useState(false)

  useEffect(() => {
    if(offTm) {
      clearTimeout(offTm)
    }
    setTimeout(() => {
      setIsOff(true)
    }, 868)

    return () => {
      if(offTm) {
        clearTimeout(offTm)
      }
    }
  }, [])

  return (
    <div className={`screen-loader${isOff ? ' screen-loader--off' : ''}`} style={{
      background: '#dc232d'
    }}>
      <span className="loader" style={{
        borderBottomColor: '#f9c753'
      }}></span>
    </div>
  )
}

export default ScreenLoader
